import styled from 'styled-components';
import {baseStyle} from '../styles';

export const Span = styled.span`
  ${baseStyle}
`;
